import { AppEntities } from "../../../../config/entities";
import { NewCatalogListView } from "../../../Shared/NewCatalogListView";

const EmployeeList = () => {
    const fields = [
        { title: "Name", fieldName: "name" },
    ];

    return (
        <>
            <NewCatalogListView fields={fields} entity={AppEntities.Employee} />
        </>
    );
}

export default EmployeeList;

